import React from "react";

import { Modal } from "antd";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./editor.scss";
import ImageManager from "containers/image/imageManager/imageManager";

// Accessing the Quill backing instance using React ref functions

const CustomButton = () => <span className="octicon octicon-star" />;

const CustomToolbar = () => (
  <div id="toolbar">
    <select
      className="ql-header"
      defaultValue={""}
      onChange={(e) => e.persist()}
    >
      <option value="1" />
      <option value="2" />
      <option />
    </select>
    <button className="ql-bold" />
    <button className="ql-italic" />
    <select defaultValue="red" className="ql-color">
      <option value="red" />
      <option value="green" />
      <option value="blue" />
      <option value="orange" />
      <option value="violet" />
      <option value="#d0d1d2" />
      <option />
    </select>
    <button className="ql-insertStar">
      <CustomButton />
    </button>
  </div>
);

export default class Editor extends React.Component {
  quillRef: any;
  reactQuillRef: any;

  constructor(props: any) {
    super(props);
    this.state = { editorHtml: "", mountedEditor: false };
    this.quillRef = null;
    this.reactQuillRef = null;
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.attachQuillRefs = this.attachQuillRefs.bind(this);
    this.insertStar = this.insertStar.bind(this);
  }

  componentDidMount() {
    this.attachQuillRefs();
  }

  componentDidUpdate() {
    this.attachQuillRefs();
  }

  attachQuillRefs() {
    // Ensure React-Quill reference is available:
    if (typeof this.reactQuillRef.getEditor !== "function") return;
    // Skip if Quill reference is defined:
    if (this.quillRef != null) return;

    const quillRef = this.reactQuillRef.getEditor();
    if (quillRef != null) this.quillRef = quillRef;
  }

  handleClick() {
    var range = this.quillRef.getSelection();
    let position = range ? range.index : 0;
    this.quillRef.insertText(position, "Hello, World! ");
  }

  handleChange(html: any) {
    this.setState({ editorHtml: html });
  }

  insertStar() {
    const instance = this.reactQuillRef.getEditor();
    console.log(instance);
    const cursorPosition = instance.getSelection().index;
    // const cursorPosition = this.quill.getSelection().index;
    instance.insertText(cursorPosition, "★");
    instance.setSelection(cursorPosition + 1);
  }

  text: string =
    ' With coronavirus outbreaks continuing to spread across the world, the United States is "likely" to see a shortage of generic pharmaceutical drugs, according to a new federal intelligence<br/><br/>  report obtained by ABC News.  The report, prepared by the Department of Homeland Security and distributed Thursday to law enforcement and government agencies around the country, warned that the U.S. is already seeing shortages of more than 200 drugs and medical supplies due to strains on the supply chain caused by international shutdowns early on in the pandemic.  \n Those shortages would only be made worse should unchecked outbreaks force yet another round of widespread shutdowns, the analysts concluded,<br/><br/>  further straining the system in a way that many U.S.-based pharmaceutical companies would be "unable to quickly offset." MORE: Demand for dexamethasone soars after promising findings in UK  "Chinese factories that produce raw ingredients for common antibiotics closed for weeks as of March and India\'s lockdown extended until the end of May," the report said, citing news reports. "France, Germany, and China have also considered re-imposing lockdown measures as COVID-19 cases have begun to re-emerge."  The warning comes as officials in some states have already halted some reopening plans or closed back down as coronavirus cases rise in at least 29 states, according to an ABC News analysis. Florida reported just under 9,000 new cases on Friday, the highest number since the start of the pandemic. Elise Amendola/AP, File In this June 15, 2018 photo, <br/><br/> pharmaceuticals are seen in North Andover, Mass. In this June 15, 2018 photo, pharmaceuticals are seen in North Andover, Mass.Elise Amendola/AP, File  Dr. Anthony Fauci, the nation\'s top infectious disease official, made what he called a "plea" to the country on Friday to understand that the outbreaks, which are mainly in the South and West, could potentially spread to the entire country.  "If we don\'t extinguish the outbreak, sooner or later, even ones that are doing well are going to be vulnerable to the spread," Fauci said. "So we need to take that into account because we are all in it together, and the only way we\'re going to end it is by ending <br/><br/> it together."  Vice President Mike Pence, however, said the country has made "truly remarkable progress" in moving forward and commended "all 50 states in this country are opening up safely and responsibly" before acknowledging some increases. MORE: Amid pandemic, Trump administration asks Supreme Court to overturn Obamacare  Dr. Jay Bhatt, former medical chief at the American Hospital Association, called the report "extremely concerning" -- especially in the middle of a pandemic.  "Accessing<br/><br/><br/>  affordable generic medications for vulnerable populations can mean the difference between a good outcome and a bad outcome," said Bhatt, an ABC News contributor. "As infections and hospitalizations rise, our patients can\'t endure shortages from lifesaving medications. We have to apply our lessons from several months ago so we don\'t end up in dire straits." Danish Siddiqui/Reuters, File An employee inspects tablets as they move along the production line at a pharmaceutical plant of Lupin, India\'s No. 2 drugmaker, in Verna, in the western state of Goa, India, June 9, 2017. An employee inspects tablets as they move along the production line at a pharmaceutical plant of Lupin, India\'s No. 2 drugmaker, in Verna, in the western state of Goa, India, June 9, 2017.Danish Siddiqui/Reuters, File  The report further warned drug shortages would have a disproportionate effect on low-income Americans.  A decrease in generic pharmaceuticals, which are significantly less expensive than their brand-name counterparts, would "most risk the health of low-income and unemployed Americans," who have already been hard hit by the economic hardships of the pandemic, the report found. MORE: Feds investigate purportedly faulty COVID-19 test components  "Individuals who cannot afford generic pharmaceuticals are unlikely to switch to brand-name prescriptions because<br/><br/>  they can cost as much as 95 percent more," the report said, citing data from a U.S. pharmaceutical research company and a Food and Drug Administration study.  "I am worried about underserved communities and safety net hospitals without significant resources in urban and rural communities as well," Bhatt said. "I hope hospitals and states not facing shortages can share with those that are to meet the need." ';

  render() {
    const formats = [
      "header",
      "font",
      "background",
      "color",
      "code",
      "size",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "list",
      "bullet",
      "indent",
      "script",
      "align",
      "direction",
      "link",
      "image",
      "code-block",
      "formula",
      "video",
    ];
    const modules = {
      // toolbar: [
      //   ["bold", "italic", "underline", "strike"], // toggled buttons
      //   ["blockquote", "code-block"], // blocks
      //   [{ header: 1 }, { header: 2 }], // custom button values
      //   [{ list: "ordered" }, { list: "bullet" }], // lists
      //   [{ script: "sub" }, { script: "super" }], // superscript/subscript
      //   [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      //   [{ direction: "rtl" }], // text direction
      //   [{ size: ["small", false, "large", "huge"] }], // custom dropdown
      //   [{ header: [1, 2, 3, 4, 5, 6, false] }], // header dropdown
      //   [{ color: [] }, { background: [] }], // dropdown with defaults
      //   [{ font: [] }], // font family
      //   [{ align: [] }], // text align
      //   ["clean"], // remove formatting
      // ],
      toolbar: {
        container: "#toolbar",
        handlers: {
          insertStar: this.insertStar,
        },
      },
      clipboard: {
        matchVisual: false,
      },
    };
    return (
      <div>
        <CustomToolbar />
        <ReactQuill
          ref={(el) => {
            this.reactQuillRef = el;
          }}
          theme={"snow"}
          onChange={this.handleChange}
          modules={modules}
          formats={formats}
          defaultValue={this.text}
        // defaultValue={"123"}
        />
        <button onClick={this.handleClick}>Insert Text</button>
        <Modal className="editor-modal-imagemanager" centered visible>
          <ImageManager />
        </Modal>
      </div>
    );
  }
}

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
